"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _NotifyIcon = _interopRequireDefault(require("./NotifyIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SortableTableHeaderCells = function SortableTableHeaderCells(_ref) {
  var columns = _ref.columns,
    order = _ref.order,
    orderBy = _ref.orderBy,
    setOrder = _ref.setOrder,
    setOrderBy = _ref.setOrderBy;
  var handleRequestSort = function handleRequestSort(event, property) {
    var isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  var createSortHandler = function createSortHandler(property) {
    return function (event) {
      handleRequestSort(event, property);
    };
  };
  return columns.map(function (column) {
    return column.sortable ? /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      key: column.id,
      sortDirection: orderBy === column.id ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_material.TableSortLabel, {
      active: orderBy === column.id,
      direction: orderBy === column.id ? order : 'asc',
      onClick: createSortHandler(column.id),
      IconComponent: function IconComponent() {
        return /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
          fontSize: "medium",
          iconName: order === 'asc' && orderBy === column.id ? 'tableUpArrow' : 'tableDownArrow'
        });
      }
    }, column.label)) : /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      key: column.id
    }, column.label);
  });
};
SortableTableHeaderCells.propTypes = {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  order: _propTypes["default"].string.isRequired,
  setOrder: _propTypes["default"].func.isRequired,
  orderBy: _propTypes["default"].string.isRequired,
  setOrderBy: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = SortableTableHeaderCells;